/**
 * vc-pay.js — /video-colorize: готовое видео — Премиум или токены (23.10.2026).
 *
 * Почему (config/video-colorize.php): бесплатная полная колоризация видео на
 * рынке не встречается, а суточный «один файл бесплатно» за месяц сработал как
 * стена ОДИН раз — то есть был «бесплатно всем». Теперь предпросмотр (кадр,
 * «Предпросмотр 5 сек», «▶», предметы и слежение) — для всех, а готовый ролик —
 * Премиум (без счёта) или токены за минуту готового видео (начатые 10 с).
 *
 * Деньги считает сервер (VideoColorizePayHandler): страница просит резерв на
 * длину ролика перед рендером, списывает его, когда файл собран, и возвращает
 * при отмене или провале. Премиум сервер узнаёт сам — страница из кэша одна на
 * всех и про тариф знать не обязана.
 *
 * Покупка токенов идёт через общую кассу (token-wall.js, ссылка «Купить
 * токены» с data-tmb-short). Касса после оплаты ПЕРЕЗАГРУЖАЕТ страницу (виджет
 * карты уходит на return_url, СБП — reload), и загруженный фильм с выделенными
 * предметами пропадал бы. Поэтому перед кассой файл и предметы кладутся в
 * хранилище работы (__workStorage, IndexedDB), а после возврата возвращаются в
 * тул сами (не старше 40 минут, один раз).
 *
 *   VcPay.init(cfg)                 cfg: {infoUrl, verbUrl(verb), t, proUrl, planName, seconds(), stashState(), restoreState(s), zone}
 *   VcPay.begin({seconds, key})     → {pro:true} | {tokens, paid, capture(), release(reason)} | null (стена показана)
 *   VcPay.refresh()                 цена и баланс заново (файл, длина, качество поменялись)
 */
(function (root) {
    'use strict';
    if (root.VcPay) return;

    var CFG = null, T = {}, info = null, infoP = null;
    var STASH_DB = 'timbrica_vc_pay', STASH_STORE = 'ret', STASH_TTL = 40 * 60000;
    var $ = function (id) { return document.getElementById(id); };
    function t(k, map) { var s = String(T[k] || k); for (var m in (map || {})) s = s.split(':' + m).join(map[m]); return s; }
    function tel(f, p) { try { root.__ae && root.__ae('feature_use', Object.assign({ slug: 'video-colorize', f: f }, p || {})); } catch (_) { } }
    function num(n) { try { return Number(n).toLocaleString(root.__intlLocale ? root.__intlLocale() : undefined); } catch (_) { return String(n); } }
    function csrf() { var m = document.querySelector('meta[name="csrf-token"]'); return m ? m.getAttribute('content') : ''; }

    function loadInfo(force) {
        if (infoP && !force) return infoP;
        infoP = fetch(CFG.infoUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; })
            .then(function (j) { info = j; render(); return j; });
        return infoP;
    }
    function isPro() { return !!((info && info.pro) || (root.__isProNow && root.__isProNow(false))); }
    function price(sec) {
        if (!info) return 0;
        var step = Math.max(1, info.step_sec || 10), steps = Math.max(1, Math.ceil(Math.max(0, sec) / step - 1e-9));
        return Math.ceil(steps * (info.per_minute || 0) * step / 60 - 1e-9);   // as VideoColorizePayHandler::priceFor
    }

    /* ── the line under «Раскрасить видео» ──────────────────────────────────── */
    // The message stays until the next press: price refreshes (file, quality,
    // length) redraw the line and must not wipe «charged» or «restored».
    var notice = null;
    function render(state) {
        if (state !== undefined) notice = state;
        state = notice;
        var box = $('vcPay'); if (!box) return;
        var sec = CFG.seconds ? CFG.seconds() : 0;
        if (!info || !info.enabled || isPro() || !(sec > 0)) { box.hidden = true; return; }
        box.hidden = false;
        var total = price(sec);
        $('vcPayLine').textContent = t('pay_line', { plan: CFG.planName || '', total: num(total), per: num(info.per_minute) });
        var bal = $('vcPayBalance');
        if (bal) { bal.hidden = !info.logged_in; bal.textContent = t('pay_balance', { n: num(info.balance || 0) }); }
        var msg = $('vcPayMsg');
        if (msg) {
            msg.hidden = !state;
            msg.className = 'vc-pay-msg' + (state && state.kind === 'err' ? ' err' : '');
            msg.textContent = state ? state.text : '';
        }
        var top = $('vcPayTopup');
        if (top) {
            top.hidden = !info.store_url;
            if (info.store_url) top.setAttribute('href', info.store_url);
            var short = Math.max(0, total - (info.balance || 0));
            if (short > 0) top.setAttribute('data-tmb-short', String(short)); else top.removeAttribute('data-tmb-short');
        }
        var pro = $('vcPayPro'); if (pro) pro.hidden = !CFG.proUrl;
    }
    function wall(text, kind) {
        render({ text: text, kind: kind || 'warn' });
        var box = $('vcPay');
        try { box && box.scrollIntoView && box.scrollIntoView({ block: 'nearest' }); } catch (_) { }
    }

    function post(verb, body) {
        return fetch(CFG.verbUrl(verb), {
            method: 'POST', credentials: 'same-origin', cache: 'no-store',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CSRF-TOKEN': csrf(), 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body)
        }).then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, j: j || {} }; });
        });
    }
    function runId() {
        var a = 'abcdefghijkmnpqrstuvwxyz23456789', s = '';
        for (var i = 0; i < 10; i++) s += a.charAt(Math.floor(Math.random() * a.length));
        return s;
    }

    /**
     * Before a full render. Resolves:
     *   {pro:true}                      — Премиум (or the token lane is off): the page keeps its own counter
     *   {tokens, paid, capture, release} — the hold is placed; capture when the file is built
     *   null                            — not now; the reason is already on the screen
     */
    async function begin(opts) {
        notice = null;
        var j0 = await loadInfo(true);
        if (!j0) { wall(t('pay_err'), 'err'); tel('pay_info_failed', {}); return null; }
        if (!j0.enabled || j0.pro) return { pro: true };
        if (!j0.logged_in) {
            wall(t('pay_login', { plan: CFG.planName || '' }));
            tel('pay_wall', { why: 'login', sec: Math.round(opts.seconds) });
            return null;
        }
        var run = runId(), key = String(opts.key || '').slice(0, 24);
        var r;
        try { r = await post('reserve', { key: key, run: run, seconds: Math.max(0.1, opts.seconds) }); }
        catch (e) { wall(t('pay_err'), 'err'); tel('pay_reserve_failed', { status: 0 }); return null; }
        var j = r.j;
        if (r.status === 200 && j.ok) {
            if (j.pro) return { pro: true };
            if (typeof j.balance === 'number' && info) info.balance = j.balance;
            if (j.paid) {
                render({ text: t('pay_paid_before'), kind: 'ok' });
                tel('pay_repeat_free', { sec: Math.round(opts.seconds) });
                return { pro: false, paid: true, tokens: 0, capture: function () { return Promise.resolve(); }, release: function () { return Promise.resolve(); } };
            }
            tel('pay_reserved', { tokens: j.tokens, sec: Math.round(opts.seconds) });
            render();
            var settled = false;
            return {
                pro: false, paid: false, tokens: j.tokens,
                capture: function () {
                    if (settled) return Promise.resolve(); settled = true;
                    return post('capture', { key: key, run: run }).then(function (c) {
                        if (info && c.j && typeof c.j.balance === 'number') info.balance = c.j.balance;
                        tel('pay_captured', { tokens: c.j && c.j.charged, status: c.status });
                        render(c.j && c.j.charged ? { text: t('pay_charged', { n: num(c.j.charged) }), kind: 'ok' } : undefined);
                    }).catch(function () { tel('pay_capture_failed', {}); });
                },
                release: function (reason) {
                    if (settled) return Promise.resolve(); settled = true;
                    return post('release', { key: key, run: run, reason: String(reason || 'cancel').slice(0, 40) }).then(function (c) {
                        if (info && c.j && typeof c.j.balance === 'number') info.balance = c.j.balance;
                        tel('pay_released', { reason: reason || 'cancel' }); render();
                    }).catch(function () { tel('pay_release_failed', {}); });
                }
            };
        }
        if (r.status === 402) {
            if (info) info.balance = typeof j.balance === 'number' ? j.balance : info.balance;
            var need = Math.max(0, (j.need || price(opts.seconds)) - (j.balance || 0));
            wall(j.reason === 'held' ? t('pay_held') : t('pay_short', { n: num(need), plan: CFG.planName || '' }));
            var top = $('vcPayTopup'); if (top && need > 0) top.setAttribute('data-tmb-short', String(need));
            tel('pay_wall', { why: j.reason || 'empty', need: need, sec: Math.round(opts.seconds) });
            return null;
        }
        if (r.status === 401 || r.status === 419) { wall(t('pay_login', { plan: CFG.planName || '' })); tel('pay_wall', { why: 'login' }); return null; }
        wall(t('pay_err'), 'err'); tel('pay_reserve_failed', { status: r.status });
        return null;
    }

    /* ── keep the work across the cashier's reload ──────────────────────────── */
    function stashDb() {
        if (!root.__workStorage) return Promise.resolve(null);
        return root.__workStorage.open(STASH_DB, 1, function (db) {
            if (!db.objectStoreNames.contains(STASH_STORE)) db.createObjectStore(STASH_STORE);
        }).then(function (h) { return h && h.db; }).catch(function () { return null; });
    }
    function stash() {
        var s = CFG.stashState ? CFG.stashState() : null;
        if (!s || !s.file) return Promise.resolve(false);
        return stashDb().then(function (db) {
            if (!db) return false;
            return new Promise(function (res) {
                var tx = root.__workStorage.tx(db, [STASH_STORE]);
                tx.objectStore(STASH_STORE).put({ ts: Date.now(), path: location.pathname, state: s }, 'last');
                tx.oncomplete = function () { res(true); };
                tx.onerror = tx.onabort = function () { res(false); };
            });
        }).then(function (ok) { tel('pay_stash', { ok: ok ? 1 : 0, mb: Math.round(((s.file && s.file.size) || 0) / 1048576) }); return ok; })
          .catch(function () { return false; });
    }
    function takeStash() {
        return stashDb().then(function (db) {
            if (!db) return null;
            return new Promise(function (res) {
                var tx = root.__workStorage.tx(db, [STASH_STORE]), st = tx.objectStore(STASH_STORE), out = null;
                var g = st.get('last');
                g.onsuccess = function () { out = g.result || null; st.delete('last'); };
                tx.oncomplete = function () { res(out); };
                tx.onerror = tx.onabort = function () { res(null); };
            });
        }).catch(function () { return null; });
    }
    function restoreAfterPurchase() {
        return takeStash().then(function (rec) {
            if (!rec || !rec.state || !rec.state.file) return;
            if (rec.path !== location.pathname || Date.now() - rec.ts > STASH_TTL) { tel('pay_stash_stale', {}); return; }
            tel('pay_stash_restored', { mb: Math.round((rec.state.file.size || 0) / 1048576) });
            if (CFG.restoreState) CFG.restoreState(rec.state);
            render({ text: t('pay_restored'), kind: 'ok' });
        });
    }

    function init(cfg) {
        CFG = cfg || {}; T = CFG.t || {};
        var top = $('vcPayTopup');
        // pointerdown, not click: the cashier takes the click in its own handler
        // and the store write must already be under way when it does.
        if (top) {
            top.addEventListener('pointerdown', function () { stash(); });
            top.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') stash(); });
        }
        var pro = $('vcPayPro');
        if (pro && CFG.proUrl) {
            pro.setAttribute('href', CFG.proUrl);
            pro.addEventListener('pointerdown', function () { stash(); tel('pay_premium_click', {}); });
        }
        document.addEventListener('tier-bootstrap:ready', function () { render(); });
        // tokens bought in another tab, or the plan changed there
        document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && info) loadInfo(true); });
        loadInfo(false).then(function () { restoreAfterPurchase(); });
    }

    root.VcPay = { init: init, begin: begin, refresh: function () { render(); }, isPro: isPro, price: price,
                   _stash: stash, _takeStash: takeStash };
})(window);
